import { render, staticRenderFns } from "./TagsDropdown.component.vue?vue&type=template&id=6373fe7e&scoped=true&"
import script from "./TagsDropdown.component.vue?vue&type=script&lang=js&"
export * from "./TagsDropdown.component.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdown.component.vue?vue&type=style&index=0&id=6373fe7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373fe7e",
  null
  
)

export default component.exports